import React, { useState, useMemo } from "react";
import { MainSection, Section, SectionTitle, Card, SectionTitleRow } from "../common_components/Layout";
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";
import { SessionHighlightUpcomingWithMission } from "../common_components/SessionHighlights";
import { useNavigate } from "react-router-dom";
import DownArrowIcon from "../../../../../../assets/images/researcher_app/dashboard/caret_down_white.png";
import UserIcon from "../../../../../../assets/images/researcher_app/dashboard/session_user_purple.png";

import DateFormatting from "../common_components/DateFormatting";

function UpcomingSessionsSection(props) {
    const navigate = useNavigate();
    const [showAll, setShowAll] = useState(false);
    var sessionsHighlighted = 6;
    const remainingSessionsHighlighted = props.sessions.length - sessionsHighlighted;

    function showMore() {
        setShowAll(true);
    }

    const missionColors = [
        "#9C62FF40", // purple
        "#FF48ED40", // pink
        "#32BAFF40", // blue
        "#FF5D5240", // red
        "#FFBD5240", // orange
        "#8DC45F40", // green
    ];

    const singleMissionColor = "#00000000"

    const missionIdToColor = useMemo(() => {
        if (!props.sessions || props.sessions.length == 0) {
            return {};
        }
        const map = {};
        let colorIndex = 0;
        for (const session of props.sessions) {
            const missionId = session.mission_id;
            if (!map[missionId]) {
                map[missionId] = missionColors[colorIndex % missionColors.length];
                colorIndex++;
            }
        }
        if (props.sessions.length == 1) {
            map[props.sessions[0].mission_id] = singleMissionColor;
        }
        return map;
    }, [props.sessions]);

    return (
        <Section>
            <SectionTitleRow>
                <SectionTitle title="Upcoming Sessions" />
                {/* <TertiaryButton text="See All" onClick={() => navigate("/sessions/")} /> */}
            </SectionTitleRow>
            {!props.loadSessionsComplete ? <CenteredLoadingIcon /> :
                props.sessions.length == 0 ? <EmptySessionsCard /> :
                    <div className="sessions-cards-and-show-more-container">
                        <div className="sessions-cards-container">
                            {props.sessions.map((session, index) => {
                                if (!showAll && index >= sessionsHighlighted) {
                                    return;
                                }
                                return (
                                    <UpcomingSession
                                        key={index}
                                        session={session}
                                        timezone={session.timezone}
                                        onClick={() => navigate("/missions/" + session.mission_id + "/sessions/" + session.id)}
                                        missionColor={missionIdToColor[session.mission_id]}
                                    />
                                )
                            })}
                        </div>
                        <div className="show-more-container">
                            {!showAll && remainingSessionsHighlighted > 0 &&
                                <ShowMoreButton numberMoreSessions={remainingSessionsHighlighted} showMore={showMore} />
                            }
                        </div>
                    </div>

            }
        </Section>
    )
}

function UpcomingSession(props) {
    const [date, time] = DateFormatting.parseISOStringToReadableDateAndTime(props.session.start_time, props.timezone);

    const style = props.missionColor == "#00000000" ? {} : { backgroundColor: props.missionColor, borderRadius: "4px", padding: "2px 4px" }


    return (
        <div className="upcoming-sessions-card" onClick={props.onClick}>
            <div className="session-name-section-div">
                <div className="user-icon-div">
                    <div className="user-icon-holder">
                        <img src={UserIcon} />
                    </div>
                </div>
                <div className="session-name-div">
                    <div className="session-name-text">
                        {props.session.first_name}
                    </div>

                    <div className="session-mission-text" style={style}>
                        {props.session.mission_name}
                    </div>

                </div>
            </div>
            <div className="session-date-div">
                <div className="session-date-text">
                    {date}
                </div>
                <div className="session-time-text">
                    {time}
                </div>
            </div>
        </div>
    )

}

function EmptySessionsCard() {
    return (
        <div className="empty-sessions-card">
            No scheduled research sessions.
        </div>
    )
}

function ShowMoreButton(props) {
    return (
        <div className="show-more-button-div" onClick={() => props.showMore()} >
            <div className="show-more-button-text">
                Show {props.numberMoreSessions} more sessions
            </div>
            <img src={DownArrowIcon} />
        </div>
    )
}

export default UpcomingSessionsSection;